/**
 * @file Submission read-only / review UI components — DatasetOverviewFormSection.tsx.
 */

import React from "react";
import CollapsiblePanel from "../CollapsiblePanel";
import type { DatasetOverviewSectionKey } from "./types";

/** Type definition — Dataset Overview Form Section Props. */
export type DatasetOverviewFormSectionProps = {
  sectionKey: DatasetOverviewSectionKey | string;
  title: string;
  description?: string;
  expanded: boolean;
  onExpandedChange: (open: boolean) => void;
  children: React.ReactNode;
  className?: string;
};

/** Collapsible Dataset Overview section (Contributor, Publication, A1, etc.). */
const DatasetOverviewFormSection: React.FC<DatasetOverviewFormSectionProps> = ({
  sectionKey,
  title,
  description,
  expanded,
  onExpandedChange,
  children,
  className = "",
}) => (
  <CollapsiblePanel
    panelId={sectionKey}
    variant="section"
    title={title}
    description={description}
    expanded={expanded}
    onExpandedChange={onExpandedChange}
    className={`dataset-overview-form-section ${className}`.trim()}
  >
    {children}
  </CollapsiblePanel>
);

/** React component — Dataset Overview Form Section. */
export default DatasetOverviewFormSection;
